/* AUTO-GENERATED - COMPILED FROM TYPESCRIPT, DO NOT EDIT DIRECTLY */
const URL_PARAMS_STORAGE_KEY = "URL_Params";
function getUrlParam(paramName) {
  try {
    const stored = localStorage.getItem(URL_PARAMS_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.latest?.[paramName]) {
        return parsed.latest[paramName];
      }
    }
  } catch (error) {
    console.error("Error getting URL parameter from localStorage:", error);
  }
  return new URLSearchParams(window.location.search).get(paramName) || void 0;
}
function onDOMReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    callback();
  }
}
async function post(url, body, secret) {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Shopify-Hmac-SHA256": secret },
      body: JSON.stringify(body),
      mode: "cors"
    });
    if (!response.ok) {
      console.error(`POST request failed: ${response.status} ${response.statusText}`, {
        url,
        status: response.status
      });
      return void 0;
    }
    const text = await response.text();
    return text.length > 0 ? JSON.parse(text) : void 0;
  } catch (error) {
    console.error("POST request failed:", error);
    return void 0;
  }
}
async function get(url, secret) {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json", "X-Shopify-Hmac-SHA256": secret },
      mode: "cors"
    });
    if (!response.ok) {
      console.error(`GET request failed: ${response.status} ${response.statusText}`, {
        url,
        status: response.status
      });
      return void 0;
    }
    const text = await response.text();
    return text.length > 0 ? JSON.parse(text) : void 0;
  } catch (error) {
    console.error("GET request failed:", error);
    return void 0;
  }
}
async function requestPost(body) {
  if (typeof window.zygRequestPostInternal !== "function") {
    console.error("request is not defined");
    return void 0;
  }
  try {
    return await window.zygRequestPostInternal("", body);
  } catch (error) {
    console.error("Backend request failed:", error);
    return void 0;
  }
}
async function requestGet(url) {
  if (typeof window.zygRequestGetInternal !== "function") {
    console.error("request is not defined");
    return void 0;
  }
  try {
    return await window.zygRequestGetInternal(url);
  } catch (error) {
    console.error("Backend request failed:", error);
    return void 0;
  }
}
async function requestPostToPath(path, body) {
  if (typeof window.zygRequestPostInternal !== "function") {
    console.error("requestPostToPath is not defined");
    return void 0;
  }
  try {
    return await window.zygRequestPostInternal(path, body);
  } catch (error) {
    console.error("Backend POST request failed:", error);
    return void 0;
  }
}
window.zygGet = get;
window.zygPost = post;
window.zygRequestPost = requestPost;
window.zygRequestGet = requestGet;
window.zygRequestPostToPath = requestPostToPath;
const STORE_CONFIG_PATH = (domain) => `store-config/${encodeURIComponent(domain)}`;
const URL_PARAM_UTM_CAMPAIGN = "utm_campaign";
const QUERY_PARAM_PATH = "path";
function buildStoreConfigUrl(domain) {
  const params = new URLSearchParams();
  params.set(QUERY_PARAM_PATH, window.location.pathname);
  const utmCampaign = getUrlParam(URL_PARAM_UTM_CAMPAIGN);
  if (utmCampaign) {
    params.set(URL_PARAM_UTM_CAMPAIGN, utmCampaign);
  }
  return `${STORE_CONFIG_PATH(domain)}?${params.toString()}`;
}
async function getStoreConfig(domain) {
  return await window.zygRequestGet(buildStoreConfigUrl(domain));
}
async function loadStoreConfig(domain) {
  try {
    window.zygStoreConfig = await getStoreConfig(domain);
  } catch (error) {
    console.error("[zyg] Failed to load store config:", error);
  }
}
const SCRIPT_SELECTOR = "script[data-zyg-store-config]";
function autoInit() {
  const script = document.querySelector(SCRIPT_SELECTOR);
  const domain = script?.dataset.domain;
  if (!domain) {
    return;
  }
  onDOMReady(() => void loadStoreConfig(domain));
}
autoInit();
window.zygGetStoreConfig = getStoreConfig;
